export default __webpack_public_path__ + "static/media/about1.c4085dc9.jpg";